export enum ObjectType {
  Boolean,
  Date,
  Function,
  Number,
  Object,
  String,
  Unknown
}

export function getType(obj: unknown): ObjectType {
  const type = Object.prototype.toString.call(obj);

  switch (type) {
    case `[object Boolean]`:
      return ObjectType.Boolean;
    case `[object Date]`:
      return ObjectType.Date;
    case `[object Function]`:
      return ObjectType.Function;
    case `[object Number]`:
      return ObjectType.Number;
    case `[object Object]`:
      return ObjectType.Object;
    case `[object String]`:
      return ObjectType.String;
    default:
    // ignore intentionally
  }

  return ObjectType.Unknown;
}

export function extract<T>(obj: T, ...keys: string[]): Record<string, unknown> {
  const output = {};
  const sourceKeys = Object.keys(obj);

  for (const key of keys) {
    if (!sourceKeys.includes(key)) {
      continue;
    }

    output[key] = obj[key];
  }

  return output;
}

export function isEmpty<T>(obj: T): boolean {
  if (obj == null) {
    return true;
  }

  return Object.entries(obj).length === 0;
}

export function isNotEmpty<T>(obj: T): boolean {
  return !isEmpty(obj);
}

export function isObject(o: unknown) {
  return getType(o) === ObjectType.Object;
}

export function deepAssign(target, source) {
  if (!isObject(target) || !isObject(source)) {
    return target;
  }

  for (const key in source) {
    if (isObject(source[key])) {
      if (target[key] == null) {
        Object.assign(target, { [key]: {} });
      }

      deepAssign(target[key], source[key]);
    } else {
      Object.assign(target, { [key]: source[key] });
    }
  }

  return target;
}
